import React from "react";

interface StarsProps {
    className?: string;
    width?: string;
    height?: string;
    rating: number;
    setRating: (value: number) => void;
    starColor?: string;
    disableColor?: string;
}


const ReviewStars: React.FC<StarsProps> = ({
    rating,
    className = "",
    width = "155",
    height = "26",
    setRating,
    starColor = "#2376E5",
    disableColor = "#ddd",
}) => {
    const handleClick = (v: number) => {
        setRating(v);
    };

    return (
        <div className={`${className} flex items-center`}>
            <svg
                width={width}
                height={height}
                viewBox="0 0 155 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13.748 0L16.8346 8.98278H26.8231L18.7422 14.5344L21.8288 23.5172L13.748 17.9656L5.66712 23.5172L8.75373 14.5344L0.672873 8.98278H10.6614L13.748 0Z"
                    stroke={rating > 0.5 ? starColor : disableColor}
                    fill={rating > 0.5 ? starColor : disableColor}
                    onClick={() => handleClick(1)}
                    className="cursor-pointer "
                />
                <path
                    d="M45.474 0L48.5607 8.98278H58.5492L50.4683 14.5344L53.5549 23.5172L45.474 17.9656L37.3932 23.5172L40.4798 14.5344L32.3989 8.98278H42.3874L45.474 0Z"
                    stroke={rating > 1.5 ? starColor : disableColor}
                    fill={rating > 1.5 ? starColor : disableColor}
                    onClick={() => handleClick(2)}
                    className="cursor-pointer"
                />

                <path
                    d="M77.2001 0L80.2867 8.98278H90.2752L82.1944 14.5344L85.281 23.5172L77.2001 17.9656L69.1193 23.5172L72.2059 14.5344L64.125 8.98278H74.1135L77.2001 0Z"
                    stroke={rating > 2.5 ? starColor : disableColor}
                    fill={rating > 2.5 ? starColor : disableColor}
                    onClick={() => handleClick(3)}
                    className="cursor-pointer"
                />
                <path
                    d="M108.926 0L112.013 8.98278H122.001L113.92 14.5344L117.007 23.5172L108.926 17.9656L100.845 23.5172L103.932 14.5344L95.8511 8.98278H105.84L108.926 0Z"
                    stroke={rating > 3.5 ? starColor : disableColor}
                    fill={rating > 3.5 ? starColor : disableColor}
                    onClick={() => handleClick(4)}
                    className="cursor-pointer"
                />
                <path
                    d="M140.652 0L143.739 8.98278H153.727L145.646 14.5344L148.732 23.5172L140.652 17.9656L132.571 23.5172L135.658 14.5344L127.577 8.98278H137.565L140.652 0Z"
                    stroke={rating > 4.5 ? starColor : disableColor}
                    fill={rating > 4.5 ? starColor : disableColor}
                    onClick={() => handleClick(5)}
                    className="cursor-pointer"
                />
            </svg>
        </div>
    );
};

export default ReviewStars;
